import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';

import UnprocessedFilesList from './List';

import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('UNPROCESSED_FILES_PANEL', LOG_LEVELS.ERROR);

class UnprocessedFilesPanel extends Component {
  render() {
    log.debug('render(): ', this.props);
    const unprocessedDocuments = this.props.documents || [];
    return (
      <div>
        <hr />
        <h2 className="mt20"><LanguageStringResolver string='importTransactions_unprocessedFiles'/><button className="float-right link margin-top-sm" onClick={this.props.onRefreshRequest}><LanguageStringResolver string='importTransactions_refreshList'/><s-icon name="refresh" role="img" aria-label="refresh" class="ml10"></s-icon></button></h2>
        <UnprocessedFilesList documents={unprocessedDocuments}/>
        <Link data-test ="button-processed-document" className="button secondary mt10 mb10" to="/ProcessedDocuments"><LanguageStringResolver string='importTransactions_viewAll'/></Link>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state);
  log.debug('mapStateToProps(): props', props);

  return {
    // Almost all components will need to use language strings, so add them to the props from the global state
    languages: state.languages,
  };
}


function mapDispatchersToProps(dispatch) {
  return {
    //TODO: Add dispatchers (actions we expect controllers to perform) here.
  }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(UnprocessedFilesPanel);
